import { gql } from "@apollo/client";

export const FETCH_SUBSCRIPTION_INFO = gql`
  query FetchSubscriptionInfo {
    subscriptionInfo {
      id
      status
      currentPeriodEnd
      nextCreditRefreshAt
      cancelAtPeriodEnd
      seatsS
      seatsM
      seatsL
      trialEnd
      trialStarted
      isInTrial
      
      # Enhanced subscription state fields
      hasAccess
      subscriptionType
      isInGracePeriod
      gracePeriodEnd
      isExpired
      
      serviceCredits {
        id
        type
        remainingUses
        expiresAt
      }
    }
  }
`;

// New query for just checking subscription access
export const FETCH_SUBSCRIPTION_ACCESS = gql`
  query FetchSubscriptionAccess {
    hasActiveSubscription
  }
`;

// New query for detailed subscription state
export const FETCH_SUBSCRIPTION_STATE = gql`
  query FetchSubscriptionState {
    subscriptionState {
      hasAccess
      subscriptionType
      status
      currentPeriodEnd
      trialEnd
      isInTrial
      isExpired
      isInGracePeriod
      gracePeriodEnd
      isPastDue
      seats {
        S
        M
        L
        total
      }
      manualSubscription {
        grantedBy
        grantedAt
        grantReason
      }
    }
  }
`;
